import { atom } from "jotai";
import CurrentPublicationEntityRecord from "models/view-models/atoms/current-publication-entity-record";

const CurrentPublicationEntityAtom = atom<
    CurrentPublicationEntityRecord | undefined
>(undefined);

export default CurrentPublicationEntityAtom;
